import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const StackedListCell = ({ label, justifySelf, className, children })=>jsx("div", {
        className: classNames('cb-stacked-list-cell', className, justifySelf && `justify-self-${justifySelf}`),
        children: label ? jsx("p", {
            className: "label",
            children: label
        }) : jsx("div", {
            children: children
        })
    });
StackedListCell.displayName = 'StackedList.Cell';

export { StackedListCell };
//# sourceMappingURL=StackedList.Cell.es.js.map
